import React from "react";
import UniversalRouter from "universal-router";
import prefixRoutes from "./prefixRoutes";
import getHistory from "./getHistory";
import routes from "./routes";

/**
 * Configures and returns a router instance.
 *
 * Sets up a wrapper around the HTML5 history API.
 */

// Set the prefix to use PUBLIC_URL provided by Create React App
// Locally this will be '/', but on gh-pages, this will be "/bronte"
const prefix = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "";

const routerOptions: any = {
  errorHandler(error: { context: {}; code: {} }) {
    console.error(error);
    console.dir(error.context);
    return error.code === 404 ? (
      <h1>Page Not Found</h1>
    ) : (
      <h1>Oops! Something went wrong</h1>
    );
  }
};

const prefixedRoutes = prefixRoutes(routes, prefix);

export const history = getHistory({ prefix });
export default new UniversalRouter(prefixedRoutes, routerOptions);
